import React from 'react';
import Header from '../sections/Header';
import Banner from '../sections/Banner';
import Footer from '../sections/Footer';
import SectionHeader from '../composites/SectionHeader';
import FeatureCard from '../composites/FeatureCard';
import Breadcrumbs from '../sections/Breadcrumbs';
import Button from '../primitives/Button';

const AIToolsDirectory: React.FC = () => {

  const approvedTools = [
    {
      title: 'Gemini',
      description: 'Google Gemini is currently the only approved AI note-taking tool. It must be manually added by the participant during the meeting.',
      image: '/logos/Gemini.svg',
      category: 'Text Generation',
      status: 'Approved',
      link: { href: 'https://gemini.google.com', label: 'Visit Gemini', variant: 'secondary' as const, size: 'sm' as const },
    },
  ];

  const filteredTools = approvedTools;

  return (
    <>
      <Header />
      <Banner
        breadcrumbs={<Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'AI Tools' }]} />}
        title="AI Tools Directory"
        subtitle="Discover approved AI tools and resources to enhance your workflow and productivity."
        colorVariant="gradient"
        imageVariant="withImage"
        paddingVariant="default"
        showCTAs={true}
        showDefaultGraphic={true}
      />

      <div className="bg-white w-full">
        <div className="max-w-7xl mx-auto px-4 py-12">
          <SectionHeader
            heading="Approved AI Tools"
            description="These tools have been reviewed and approved for use within our organization. Each tool is categorized and includes usage guidelines."
          />


          {/* Tools Grid */}
          {filteredTools.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredTools.map((tool, idx) => (
                <FeatureCard
                  key={tool.title}
                  customImage={tool.image}
                  title={tool.title}
                  description={tool.description}
                  link={tool.link}
                  className="h-full"
                  animate={true}
                  delay={idx * 0.1}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 15c-2.34 0-4.47-.881-6.08-2.33" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">No tools found</h3>
              <p className="text-gray-600">Try adjusting your search terms or browse all approved tools.</p>
            </div>
          )}

          {/* Coming Soon Section */}
          <div className="mt-12 p-6 bg-gray-50 rounded-lg">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">More Tools Coming Soon</h3>
            <p className="text-gray-600 mb-4">
            To request approval for a new AI tool or agent, complete the AI Tool Request Form available on The Hub. Once submitted, the Hub team will review your request based on factors such as compliance with client and legal data policies, security and access controls, alignment with business needs, and fit with our agentic maturity model. Approved tools will be added to the list of those available for wider use.
            </p>
            <Button
              variant="secondary"
              size="sm"
              onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLSf7HqNbjDLxdT_CUjFW2fOzYIqI_C9Rx8mW0nL-jTxaFLyaMg/viewform', '_blank')}
            >
              Request New Tool
            </Button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default AIToolsDirectory; 